import React from 'react'
import { unSlugify } from '../../utils'

const InvoiceStatus = ({status}) => {
    return (
        <span className={`inline-block text-xs px-2 py-1 rounded 
        ${status === 'PART_PAID' && 'bg-gray-600 text-gray-500 bg-opacity-10 font-outfit capitalize'}
        ${status === 'PENDING' && 'bg-amber-600 text-amber-800 bg-opacity-10 font-outfit capitalize'}
        ${status === 'PAID_IN_FULL' && 'bg-green-600 text-green-800 bg-opacity-10 font-outfit capitalize'}
        `}>{unSlugify(status?.toLowerCase())}</span>
    )
}

export default InvoiceStatus